import React from 'react'
import { Button, Divider, Segment, Header, Grid } from 'semantic-ui-react'

import SimpleReactLightbox from "simple-react-lightbox";
import { SRLWrapper } from "simple-react-lightbox";


import robert43 from '../images/articlePictures/robert43.png'
import robertCrew45 from '../images/articlePictures/robertCrew45.png'
import robertKellion45 from '../images/articlePictures/robertKellion45.png'
import robertGloriaWedding47 from '../images/articlePictures/robertGloriaWedding47.png'
import robertKathyCarol56 from '../images/articlePictures/robertKathyCarol56.png'


const options = {
    thumbnails: {
        showThumbnails: false
    // buttons: {
    //   backgroundColor: "#1b5245",
    //   iconColor: "rgba(126, 172, 139, 0.8)",
    // },
    // caption: {
    //   captionColor: "#a6cfa5",
    //   captionFontFamily: "Raleway, sans-serif",
    //   captionFontWeight: "300",
    //   captionTextTransform: "uppercase",
    }
  };

const RobertJonesBio = () => (

<React.Fragment>
<Segment  style={{ padding: '0em 0em' }} vertical>
    <Grid celled='internally' columns='equal' stackable>
        <Grid.Row textAlign='center'>
            <Grid.Column  style={{ paddingBottom: '0em', paddingTop: '0em' }}>
                <br/>
                <Header as='h3' style={{ fontSize: '2em' }}>Robert Erskine Jones <br/> (1922 - 1962) </Header>
                <br/>
            </Grid.Column>
        </Grid.Row>

        <Grid.Row textAlign='left'>
            <Grid.Column  style={{ paddingBottom: '1em', paddingTop: '.5em' }} >
                <p class="sidePadding" style={{ fontSize: '1.33em' }}>
                <SimpleReactLightbox>
                    <SRLWrapper>
                    <div class="column">
                    {/* <SRLWrapper options={options}> */}
                    <img src={robert43} class="articlePhoto" alt="1943 - Robert Jones" />
                    </div>
                <br/>
                Robert Jones was born on January 18, 1922.  He graduated from Germantown High School on June 22, 1939.
                <br/>
                <br/>
                After he graduated from high school, he and his other moved to West Philadelphia so that he could live at home while attending the University of Pennsylvania.
                <br/>
                <br/>
                He was initiated into the Pi Kappa Alpha Fraternity on April 6, 1940.
                <br/>
                <br/>
                He joined the Army Air Force in 1943.  His service number was 13150412. In August 1943 he was stationed at the Army Air Force Classification Center- Santa Ana Army Air Base - Santa Ana, California.
                <br/>
                <br/>
                From January through March 1944 he was at Pilots Basic Training  - Chico, California.  One day after being instructed on flying a PT 13A Trainer and shooting a few landings, his instructor stepped out and said, “It’s all yours.”
                <br/>
                <br/>
                In his personal journel he recorded some of his experience:, 
                <br/>
                <br/>
                <p class="handWritten">
                “It was a great feeling you can bet and the fact that I wasn’t nervous is a tribute to the thorough training we have received.  Without my instructor, I found the lane much lighter and as a result had and as a result had to circle twice before I could set her down.  The landing was good and he sent me out again.  This time I gauged better and brought her in first shot in a good three point landing.”
                </p>
                Later he wrote, 
                <br/>
                <br/>
                <p class="handWritten">
                "We are very fortunate in that we have only one class here now so that only one half the personnel flying.
                <br/>
                <br/>
                We have a main air base where all our planes are kept and five auxiliary fields to work from.  As a result only a few of us have a field assigned each day and have all the room we need.  
                <br/>
                <br/>
                We have no crowding, as there are so many areas and fields.  Our flying area overall is about 1500 square miles so you can see we have all the room in the world.  We are assigned an area each day and a field and thus it keeps us within safe distance of each other.  You are in contact with the control towers by radio at all times and they tell you where you fly and if you're getting too close to anyone.  
                <br/>
                <br/>
                Ye Gods, but they are bugs on safety.  You can't get within a mile of another plane.  There is no congestion as there was at primary and no chance of traffic pattern collisions.  You land by radio.  That is to say that you cruise to the field and instead of landing when you think it's safe, you wait and the control tower gives you a clearance and a runway and you know you can land without competition.  It's a terrific system. 
                <br/>
                <br/>
                 This field has a record of no fatalities since the Cadet program began and a grand total of 20,872 flying hours since the last accident, which was a forced landing with no one worse than bruised.  That is the West Coast Training Command's all time record.  This is the foremost basic school out here.  Moreover with only half as many men flying we have only half as many planes to look out for - Our planes are equipped well with instruments plus a new student training warning system.  If you are flying the plane to slow, too fast, climbing too steeply, or putting too much strain on it a bank of red lights on the instrument panel light up and correct your mistake.  It's really marvelous.  
                 <br/>
                <br/>
                In training flights you have an assigned altitude and no one else has the same one.  You set your warning system on that altitude on the altimeter and if you aren't looking around and you leave that altitude the light goes on.  As a result you could fly without even looking for other planes and never run into one."
                </p>
                In April 1944, he went to Army school for Twin Engine Technique (AT-17) Stockton, California.
                <br/>
                <br/>
                When Robert was transferred to Europe, he was stationed at Podington, England, not far from Northhampton.  He was in the 325th bomb squadron, 92nd  Bomb group.
                <br/>
                <br/>
                <div class="column">
                    {/* <SRLWrapper options={options}> */}
                    <img src={robertKellion45} class="articlePhoto" alt="1945 - Robert on the left and Lt. Kellion believed to be at Podington" />
                </div>
                <br/>
                <br/>
                December 31, 1944—Robert’s B-17 received battle damage over Germany. And was forced down in Belgium.  They spent New Year’s Eve celebrating in Brussels, being entertained by RCAF men and some Belgian people.  It was one of the most interesting holidays he ever had.  Robert had a narrow escape from a German air attack the next morning.
                <br/>
                <br/>
                February 16, 1945—wrote that he went to London on a 48-hour pass.  Had a chance to see the movie “Wings of Victory” in which he and his plane was in the background.
                <br/>
                <br/>
                <div class="column">
                    {/* <SRLWrapper options={options}> */}
                    <img src={robertCrew45} class="articlePhoto" alt="1945, March 14th - Robert (seen standing on the far right) with his crew." />
                </div>
                <br/>
                <br/>
                Later he had an eight-day sojourn, which started at Luxembourg City and ended at Paris.  This time they had their B-17 shot to pieces deep in Germany.  They brought the Flying Siene back as far as Luxembourg and then had to abandon it.  They stayed in Luxembourg a few days with Patton’s outfit (Patton wasn’t there) and then got to Paris via a leave train where we were taken off the “missing in action” status and shown the city for three days.  It was shortly after returning to England on that job that we went on leave to the East home.  Robert wrote, 
                <p class="handWritten">
                “These episodes were scary at the time, but all turned out well and were lots of fun to say the least.”
                </p>
                Robert had a passionate interest in jazz and particularly Glenn Miller.  He was thrilled to be in England in the Air Force at the same time as Glenn Miller, and he actually got to meet him.
                <br/>
                <br/>
                April 25, 1945 – Robert flew on the last combat mission that the 8th Air Force flew. They bombed an Armament Plant in Pilsen, Czechoslovakia. It was his 34 th combat mission with the 92 nd Group. 
                <br/>
                <br/>
                May 1945 – Transferred to the Staff of the 325 th Squadron in France. He was stationed about thirty miles North East of Marseille. He flew to Casablanca, Port Lyantey, Africa, and Rome.
                <br/>
                <br/>
                After he came back from Europe, he was sent to Indiantown Gap outside of Harrisburg for discharge. His Aunt Betty and Cousin Marion went to the Penn Harris Hotel to meet him. They were the first family members to see him upon his return. Robert stayed with them for a few days before returning to Philadelphia. 
                <br/>
                <br/>
                After the war, Robert wanted to go into commercial flying, but his father didn’t give him the choice. He threatened to cut off all support to his mother if Robert didn’t go to law school. He hated the idea of becoming a lawyer. He was afraid he would turn out like his father. He went to law school at Dickinson School of Law at Penn State.
                <br/>
                <br/>
                Robert and Gloria became engaged on December 26, 1946.
                <br/>
                <br/>
                Robert and Gloria Margaret Cassidy were married on July 19, 1947.
                <br/>
                <br/>
                <div class="column">
                    {/* <SRLWrapper options={options}> */}
                    <img src={robertGloriaWedding47} class="articlePhoto" alt="1947 - Gloria &amp; Robert on their wedding day." />
                </div>
                <br/>
                <br/>
                Marion Kathleen Jones was born December 16, 1952 and Carol Anne Jones was born May 12, 1954.
                <br/>
                <br/>
                Robert joined the law firm of Rawle &amp; Henderson.
                <br/>
                <br/>
                On Friday, September 7, 1962, Robert checked himself into the Claridge Hotel in Atlantic City.  He was there to attend the fourth annual Bench-Bar Conference of the Philadelphia Bar Association.  Shortly after midnight he left the hotel lounge, declining a drink offered by his companions.  At around eight A.M., Robert hung himself in his room closet.
                <br/>
                <br/>
                He was buried on September 12, 1962 at West Laurel Hill Cemetary in Pennsylvania.
                <br/>
                <br/>
                <div class="column">
                    {/* <SRLWrapper options={options}> */}
                    <img src={robertKathyCarol56} class="articlePhoto" alt="1956 - Robert with his daughters, Kathy on the left &amp; Carol on the right." />
                </div>
                <br/>
                <br/>
                    </SRLWrapper>
                </SimpleReactLightbox>
                </p>
            </Grid.Column>
        </Grid.Row>
        </Grid>
    </Segment>
</React.Fragment>
)

export default RobertJonesBio